/* eslint-disable @typescript-eslint/naming-convention */
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {EMPTY, Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ApiModule} from '../api.module';
import {CommerceApiService} from './commerce-api.service';
import {Store} from '@ngrx/store';

export interface MarketingSignupPayload {
  userId: string;
  event: string;
  properties: {
    email: string;
    first_name: string;
    last_name: string;
    state?: string;
    source: string;
    unsubscribed: boolean;
  };
}

@Injectable({
  providedIn: ApiModule,
})
export class MarketingInfoService extends CommerceApiService {
  readonly controllerPath: string = 'v3/commerce/shopper/marketing';
  constructor(
    protected http: HttpClient,
    protected store: Store,
  ) {
    super(http, store);
  }

  sendMarketingSignup(payload: MarketingSignupPayload): Observable<unknown> {
    const url = this.getUrl('/signup');
    return this.POST(
      url,
      payload,
      this.getOptions({withCredentials: true}),
    ).pipe(
      catchError(error => {
        // We don't want marketing signup failures to interfere with the user experience, but we do want to log them for debugging purposes.
        // eslint-disable-next-line no-console
        console.error('Marketing signup failed', error);
        return EMPTY;
      }),
    );
  }

  getUrl(path = ''): string {
    path = `${this.controllerPath}${path}`;
    return super.getUrl(path);
  }
}
